// Jump the window to a scroll position at once. <html> has
// `scroll-behavior: smooth`, so a plain window.scrollTo(x, y) animates, and a
// re-render in the middle cuts the animation short (QA BUG-1: a unit opened
// "at the top" landed 140 px down; the inventory restore landed 20 px off).
export default function scrollInstant(top = 0) {
    try {
        window.scrollTo({ top, left: 0, behavior: 'instant' });
    } catch (e) {
        try { window.scrollTo(0, top); } catch (e2) { /* no window */ }
    }
}

/** A CSS attribute-value escape that also works where CSS.escape is missing. */
export const cssEscape = (value) => {
    const s = String(value);
    if (typeof CSS !== 'undefined' && CSS && typeof CSS.escape === 'function') return CSS.escape(s);
    return s.replace(/["\\]/g, '\\$&');
};
